import Wix from '../services/wix-sdk-polyfill';
import { loginMember } from './login-member';

export const fetchCurrentMember = () => dispatch => {
  return new Promise(resolve => {
    Wix.currentMember(member => {
      if (member) {
        dispatch(loginMember(member.data || member)).then(resolve); // OR is needed because callback is called with different data
        return;
      }
      resolve();
    });
  });
};



// WEBPACK FOOTER //
// ./app/actions/fetch-current-member.js